// i18n
import "./locales/i18n";

// highlight
import "./utils/highlight";

// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// scroll bar
// import 'simplebar/src/simplebar.css';
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider as ReduxProvider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";

// redux
import { store, persistor } from "./redux/store";
// contexts
import { SettingsProvider } from "./contexts/SettingsContext";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";
// components
import LoadingScreen from "./core/components/LoadingScreen";
import { AuthProvider as JWTAuthProvider } from "./contexts/JWTContext";
import { AuthProvider as AzureEntraAuthProvider } from "./contexts/AzureEntraContext";
import { getEnvironmentVariable } from "./utils/env";


const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);



const authType = getEnvironmentVariable("REACT_APP_AUTH_TYPE");

let AuthProvider;

switch (authType) {
  case "AzureEntraId":
    AuthProvider = AzureEntraAuthProvider;
    break;
  case "ADFS":
    AuthProvider = JWTAuthProvider;
    break;
  default:
    AuthProvider = JWTAuthProvider;
    break;
}


root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <SettingsProvider>
          <CollapseDrawerProvider>
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
